<template>
	<el-dialog
		:title="`${scene == 'add' ? '新增' : '修改'}`"
		width="550px"
		v-model="data.dialogTableVisible"
	>
		<el-form label-width="90px">
            <el-form-item label="套餐名">
                <el-input
                    type="text"
                    v-model="data.formLabelAlign.demo"
                    placeholder="请输入套餐名"
                ></el-input>
            </el-form-item>
            <el-form-item label="时长">
                <el-input
                    type="number"
                    v-model="data.formLabelAlign.time"
                    placeholder="请输入时长"
                ></el-input>
            </el-form-item>
            <el-form-item label="金额">
                <el-input
                    type="number"
                    v-model="data.formLabelAlign.price"
                    placeholder="请输入金额"
                ></el-input>
            </el-form-item>
            <el-form-item label="是否展示">
                <el-switch
                    v-model="data.formLabelAlign.status"
                    :active-value="1"
                    :inactive-value="2"
                    />
            </el-form-item>
		</el-form>
		<footer class="tac" style="margin-top: 50px">
			<el-button @click="handleCancle">取消</el-button>
			<el-button type="primary" @click="handleSave">确定</el-button>
		</footer>
	</el-dialog>
</template>

<script>
import { defineComponent, inject, reactive } from "vue";
import {apiUserParkingLotList,
} from "@/api/requestApis.js";
import {apiTimeConfigUpdate} from "@/api/carWashPackageManagement";
import {SwitchButton} from "@element-plus/icons-vue";
export default defineComponent({
    components: {SwitchButton},
	props: {
		scene: {
			type: String,
			default: "add",
		},
		currentData: {
			type: Object,
			default() {
				return {};
			},
		},
	},
	setup(props) {
		const userTypeInfo = inject("userTypeInfo");
		const handleUpdateTable = inject("handleUpdateTable");
		const data = reactive({
			cheChangName: "",
			dialogTableVisible: false,
			formLabelAlign: {
				name: "",
				parkingLotId: "",
				phone: "",
                deposit: "",
                status: 1
			},
		});

		const handleReset = () => {
			Object.keys(data.formLabelAlign).forEach((key) => {
				data.formLabelAlign[key] = "";
			});
		};

		const handleSetDefaultVal = () => {
			data.formLabelAlign.demo = props.currentData.demo;
			data.formLabelAlign.time = props.currentData.time;
			data.formLabelAlign.price = props.currentData.price;
			data.formLabelAlign.status = props.currentData.status;
		};

		const handleToggle = (val) => {
			if (val) {
				if (props.scene === "edit") {
					setTimeout(() => {
						handleSetDefaultVal();
					}, 10);
				}
			}
			data.dialogTableVisible = val;
		};
		const handleSave = async () => {
			if (props.scene === "edit") {
				await apiTimeConfigUpdate({
					...data.formLabelAlign,
                    status: data.formLabelAlign.status == 1 ? 1 : 2,
					userType: props.currentData.userType,
					id: props.currentData.id,
				});
			}
			handleToggle(false);
			handleReset();
			handleUpdateTable();
		};

		const handleCancle = () => {
			handleToggle(false);
			handleReset();
		};
		const querySearchAsync = async (val, cb) => {
			const res = await apiUserParkingLotList({
				name: val,
			});
			const list = res.map((item) => {
				return {
					value: item.name,
					...item,
				};
			});
			cb(list);
		};
		const handleSelect = (val) => {
			data.formLabelAlign.parkingLotId = val.id;
		};
		return {
			userTypeInfo,
			querySearchAsync,
			handleSelect,
			handleCancle,
			handleSave,
			handleToggle,
			data,
		};
	},
});
</script>

<style scoped>
</style>
